module.exports = __webpack_public_path__ + "img/img_0.769b8c34.png";